/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedBurnComponentDtoSchema } from "./investmentNeedBurnComponentDtoSchema.ts";
import { investmentNeedBurnPhaseDtoSchema } from "./investmentNeedBurnPhaseDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedBurnRatioDtoSchema = z.object({
  get phases() {
    return z.array(investmentNeedBurnPhaseDtoSchema).optional();
  },
  get components() {
    return z.array(investmentNeedBurnComponentDtoSchema).optional();
  },
});
